import type { CadastrarCotacaoReferenciaBody } from "@/modules/financeiro-configuracoes";
import { CAMPOS_OBRIGATORIOS, COTACAO_INVALIDA } from "./nova-cotacao-dialog.constants";

export type NovaCotacaoForm = {
  competencia: Date | null;
  moedaId: string | null;
  cotacao: number | null;
};

export const NOVA_COTACAO_VAZIA: NovaCotacaoForm = {
  competencia: null,
  moedaId: null,
  cotacao: null,
};

export const erroCompetencia = (competencia: Date | null) =>
  competencia ? null : CAMPOS_OBRIGATORIOS;

export const erroMoeda = (moedaId: string | null) => (moedaId ? null : CAMPOS_OBRIGATORIOS);

export function erroCotacao(cotacao: number | null) {
  if (cotacao === null) return CAMPOS_OBRIGATORIOS;
  return cotacao > 0 ? null : COTACAO_INVALIDA;
}

export const competenciaAnoMes = (data: Date) =>
  `${data.getFullYear()}-${String(data.getMonth() + 1).padStart(2, "0")}`;

export function montarCorpo(form: NovaCotacaoForm): CadastrarCotacaoReferenciaBody | null {
  if (!form.competencia || !form.moedaId || form.cotacao === null) return null;
  return {
    moedaId: form.moedaId,
    competencia: competenciaAnoMes(form.competencia),
    cotacao: form.cotacao,
  };
}
